import { useNavigate, useLocation, NavLink } from 'react-router-dom';
import { formatBalance, IconRight } from '@ui/src';
import { WarningReportItemTypes } from './types';

import cn from './styles.module.css';

const WarningReportItem = ({
  title,
  selectedWarningsReportCount,
  warningReportsCount,
  setShowDetalisation,
  organizationDetails,
  monitoringRules,
  withIcon,
  monitoringRuleId,
}: WarningReportItemTypes) => {
  const navigate = useNavigate();
  const { search } = useLocation();

  let buttonContent = (
    <button
      type="button"
      className={`${cn.text} ${!setShowDetalisation ? cn.notButton : ''} ${
        organizationDetails ? cn.warningDetailsText : ''
      }`}
      onClick={() => {
        if (setShowDetalisation) {
          setShowDetalisation(true);

          if (search) {
            navigate(`${search}&selectedTypeId=transactionsMonitoringRules`);
          } else {
            navigate('?selectedTypeId=transactionsMonitoringRules');
          }
        }
      }}
    >
      {title}
      {!monitoringRules && withIcon && <IconRight />}
    </button>
  );

  if (monitoringRules) {
    buttonContent = (
      <NavLink
        className={`${cn.text} ${
          organizationDetails ? cn.warningDetailsText : ''
        } ${cn.monitoringRuleLink}`}
        target="_blank"
        to={`/transaction-monitoring-rules/${monitoringRuleId}`}
      >
        <div className={cn.monitoringRuleLinkContent}>
          {title}
          <IconRight />
        </div>
      </NavLink>
    );
  }

  return (
    <div
      className={`${cn.warningsReportOverviewContentBottomLeftItem} ${
        organizationDetails ? cn.moreWidth : ''
      }`}
    >
      {buttonContent}
      <div className={cn.counts}>
        {selectedWarningsReportCount?.toString() && (
          <div className={`${cn.count} ${cn.selected}`}>
            {formatBalance(selectedWarningsReportCount || 0, undefined, 0)}
          </div>
        )}
        <div className={cn.count}>
          {formatBalance((warningReportsCount as number) || 0, undefined, 0)}
        </div>
      </div>
    </div>
  );
};

export default WarningReportItem;
